import { orderBy as _orderBy } from 'lodash';
import { GET_STATES_LIST_API } from '../constants/AppConstants';

/**
 * Service to get the list of all the states under a particular country.
 * @returns {Object} - Response received from the API along with the ok status
 */
const getStateList = async (countryId) => {
  try {
    const response = await fetch(GET_STATES_LIST_API.replace('$countryId$', countryId), {
      method: 'GET',
    });
    let json = [];
    if (response.status !== 204) {
      json = await response.json();
      json = _orderBy(json, [(states) => states.name.toLowerCase()]);
    }
    return { ok: response.ok, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: error.message } };
  }
};

export default getStateList;
